export default [
  { label: 'AppMediaMouse', width: 'label', group: true },

  { label: '应用', width: 'label' },

  { name: 'Power', code: 'KC_PWR', title: '关机' },
  { name: 'Sleep', code: 'KC_SLEP', title: '睡眠' },
  { name: 'Wake', code: 'KC_WAKE', title: '唤醒' },
  { width: 1250 },
  { name: 'Exec', code: 'KC_EXEC', title: '运行' },
  { name: 'Help', code: 'KC_HELP', title: '帮助' },
  { name: 'Menu', code: 'KC_MENU', title: '菜单' },
  { name: 'Select', code: 'KC_SLCT', title: '选择' },
  { name: 'Stop', code: 'KC_STOP', title: '停止' },
  { name: 'Again', code: 'KC_AGIN', title: '再次' },
  { name: 'Undo', code: 'KC_UNDO', title: 'Undo' },
  { name: 'Cut', code: 'KC_CUT', title: '剪切' },
  { name: 'Copy', code: 'KC_COPY', title: '拷贝' },
  { name: 'Paste', code: 'KC_PSTE', title: '粘贴' },
  { name: 'Find', code: 'KC_FIND', title: '查找' },
  { width: 0 },
  {
    name: 'Calc',
    code: 'KC_CALC',
    title: '运行计算器 (Windows)'
  },
  {
    name: 'Mail',
    code: 'KC_MAIL',
    title: '运行邮件 (Windows)'
  },
  {
    name: 'Media Player',
    code: 'KC_MSEL',
    title: '运行媒体播放器 (Windows)'
  },
  {
    name: 'My PC',
    code: 'KC_MYCM',
    title: '运行我的电脑 (Windows)'
  },
  { width: 250 },
  {
    name: 'Browser Search',
    code: 'KC_WSCH',
    title: '浏览器搜索 (Windows)',
    width: 1500
  },
  {
    name: 'Browser Home',
    code: 'KC_WHOM',
    title: '浏览器首页 (Windows)',
    width: 1500
  },
  {
    name: 'Browser Back',
    code: 'KC_WBAK',
    title: '浏览器回退 (Windows)',
    width: 1500
  },
  {
    name: 'Browser Forward',
    code: 'KC_WFWD',
    title: '浏览器前进 (Windows)',
    width: 1500
  },
  {
    name: 'Browser Stop',
    code: 'KC_WSTP',
    title: '浏览器停止 (Windows)',
    width: 1500
  },
  {
    name: 'Browser Refresh',
    code: 'KC_WREF',
    title: '浏览器刷新 (Windows)',
    width: 1500
  },
  {
    name: 'Browser Favorites',
    code: 'KC_WFAV',
    title: '浏览器收藏夹 (Windows)',
    width: 1500
  },
  //********** TODO: 实现亮度调整 **********
  {
    name: 'Brightness Up',
    code: 'KC_BRIU',
    title: 'Increase the brightness of screen (Laptop)',
    width: 1500
  },
  {
    name: 'Brightness Down',
    code: 'KC_BRID',
    title: 'Decrease the brightness of screen (Laptop)',
    width: 1500
  },  //************** */

  { label: '多媒体键', width: 'label' },

  { name: 'Previous', code: 'KC_MPRV', title: '上一曲' },
  { name: 'Next', code: 'KC_MNXT', title: '下一曲' },
  { name: 'Mute', code: 'KC_MUTE', title: '静音' },
  { name: 'Vol -', code: 'KC_VOLD', title: '音量减' },
  { name: 'Vol +', code: 'KC_VOLU', title: '音量加' },
  { name: 'Media Stop', code: 'KC_MSTP', title: '停止播放' },
  { name: 'Play', code: 'KC_MPLY', title: '播放/暂停' },
  { width: 250 },
  {
    name: 'Prev Track',
    code: 'KC_MRWD',
    title: '上一曲 / 倒带 (macOS)'
  },
  {
    name: 'Next Track',
    code: 'KC_MFFD',
    title: '下一曲 / 快进 (macOS)'
  },
  { width: 250 },
  { name: 'Eject', code: 'KC_EJCT', title: '弹出 (macOS)' },

  { label: '鼠标键', width: 'label' },

  { name: 'Mouse Up', code: 'KC_MS_U',   title: '鼠标指针向上' },
  { name: 'Mouse Down', code: 'KC_MS_D', title: '鼠标指针向下' },
  { name: 'Mouse Left', code: 'KC_MS_L', title: '鼠标指针向左' },
  { name: 'Mouse Right', code: 'KC_MS_R',title: '鼠标指针向右' },
  { width: 250 },
  { name: 'Mouse 1', code: 'KC_BTN1', title: '鼠标键 1' },
  { name: 'Mouse 2', code: 'KC_BTN2', title: '鼠标键 2' },
  { name: 'Mouse 3', code: 'KC_BTN3', title: '鼠标键 3' },
  { name: 'Mouse 4', code: 'KC_BTN4', title: '鼠标键 4' },
  { name: 'Mouse 5', code: 'KC_BTN5', title: '鼠标键 5' },
  { width: 250 },
  { name: 'Mouse Wheel Up', code: 'KC_WH_U',   title: '鼠标滚轮向上' },
  { name: 'Mouse Wheel Down', code: 'KC_WH_D', title: '鼠标滚轮向下' },
  { name: 'Mouse Wheel Left', code: 'KC_WH_L', title: '鼠标滚轮向左' },
  { name: 'Mouse Wheel Right', code: 'KC_WH_R',title: '鼠标滚轮向右' },
  { width: 250 },
  {
    name: 'Mouse Accel 0',
    code: 'KC_ACL0',
    title: '鼠标移动速度：慢速'
  },
  {
    name: 'Mouse Accel 1',
    code: 'KC_ACL1',
    title: '鼠标移动速度：中速'
  },
  {
    name: 'Mouse Accel 2',
    code: 'KC_ACL2',
    title: '鼠标移动速度：快速'
  },

  { label: '扩展 FN 键', width: 'label' },

  { name: 'F13', code: 'KC_F13', title: 'F13' },
  { name: 'F14', code: 'KC_F14', title: 'F14' },
  { name: 'F15', code: 'KC_F15', title: 'F15' },
  { name: 'F16', code: 'KC_F16', title: 'F16' },
  { name: 'F17', code: 'KC_F17', title: 'F17' },
  { name: 'F18', code: 'KC_F18', title: 'F18' },
  { name: 'F19', code: 'KC_F19', title: 'F19' },
  { name: 'F20', code: 'KC_F20', title: 'F20' },
  { name: 'F21', code: 'KC_F21', title: 'F21' },
  { name: 'F22', code: 'KC_F22', title: 'F22' },
  { name: 'F23', code: 'KC_F23', title: 'F23'  },
  { name: 'F24', code: 'KC_F24', title: 'F24'  }
];
